import * as React from 'react';

import ContentsPreviewContainer from '../../containers/QuickModeContentsPreview';

/**
 * QuickMode
 */
const QuickModeContentsPreview: React.FunctionComponent<any> = props => {
	return <ContentsPreviewContainer {...props} />;
};

export default QuickModeContentsPreview;



// WEBPACK FOOTER //
// ./src/pages/quickMode/QuickModeContentsPreview.tsx